// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuilderControl_BuildControl__18539","Label":"BuilderControl_Label__3L4QL","Less":"BuilderControl_Less__1ztZs","More":"BuilderControl_More__1skDf"};